import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiError, AuthService, BaseVisualizacao, BaseVisualizacaoService, ConfigService, DataTablesService, MessageService, Task, TaskService } from '../../core';
import { ConfigEmpresa, isConfigEmpresaVersaoIntegracaoErp1 } from '../configuracoes/app/empresa';
import { IntegrationUnidadeNegocio, IntegrationUnidadeNegocioHttpService } from '../configuracoes/integration/unidade-negocio';
import { UnidadeNegocioCrudHttpService } from './services';

import { UnidadeNegocio } from './unidade-negocio';
import { UnidadeNegocioOptions } from './unidade-negocio-options';

@Component({
    selector: 'sgt-unidade-negocio',
    templateUrl: './unidade-negocio.component.html',
    styleUrls: ['./unidade-negocio.component.less']
})
export class UnidadeNegocioComponent implements BaseVisualizacao<UnidadeNegocio>, OnInit {
    configEmpresa: ConfigEmpresa;
    isIntegracaoErpV1: boolean;
    entities: UnidadeNegocio[];
    dataTable: any;

    // Options
    options: UnidadeNegocioOptions;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private configService: ConfigService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private taskService: TaskService,
                private unidadeNegocioCrudHttpService: UnidadeNegocioCrudHttpService,
                private integrationUnidadeNegocioHttpService: IntegrationUnidadeNegocioHttpService) { }


    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isIntegracaoErpV1 = isConfigEmpresaVersaoIntegracaoErp1(this.configEmpresa);

        this.createOptions();
        this.search();
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new UnidadeNegocioOptions();
        // Import ERP v1
        this.options.canImportErp_v1 = this.canImportErp_v1();
    }

    search() {
        this.unidadeNegocioCrudHttpService.search()
            .subscribe(
                entities => {
                    this.entities = entities;
                    this.showTable();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as unidades de negócios', error)
            );
    }

    showTable() {
        this.dataTablesService.showTable('#tableUnidadeNegocio', this.dataTable)
            .then(dataTable => {
                this.dataTable = dataTable;
                this.baseVisualizacaoService.ativarArmazenamento(this.dataTable, null);
            });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: UnidadeNegocio) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: UnidadeNegocio) {
        this.messageService.confirm(`Deseja realmente excluir a Unidade de Negócio: ${entity.nome}?`).then(result => {
            if (result) {
                this.unidadeNegocioCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir a Unidade de Negócio: ${entity.nome}`, error)
                    );
            }
        });
    }

    /** Verifica se pode importar as formas de pagamentos do ERP V1 */
    private canImportErp_v1(): boolean {
        // Somente se for a versão 1
        if (!this.isIntegracaoErpV1) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

     /** Executa a integração de leitura das unidades de negócios com os sistemas ERP's */
     importErp_v1() {
        const task = new Task('Importando as unidades de negócios do sistema ERP', 'Executando importação das unidades de negócios do sistema ERP');
        this.taskService.add(task, task.description);

        const entityIntegration = new IntegrationUnidadeNegocio();
        this.integrationUnidadeNegocioHttpService.execReadIntegration(entityIntegration)
            .subscribe(
                () => {
                    this.taskService.success(task, 'Importação das unidades de negócios do sistema ERP realizada com sucesso');
                    this.search();
                },
                (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a importação das unidades de negócios do sistema ERP', error.message, error)
            );
    }
}
